module.exports = __webpack_public_path__ + "static/media/p3.659fee49.svg";